import appleFitness from '@/assets/device-icons/apple-fitness.svg';

interface AppleFitnessIconProps {
  className?: string;
}

export const AppleFitnessIcon = ({ className = "h-5 w-5" }: AppleFitnessIconProps) => {
  return (
    <img 
      src={appleFitness} 
      alt="Apple Fitness" 
      className={className}
    />
  );
};
